export default __webpack_public_path__ + "static/media/long_arrow_right.9fc8e01f.svg";